export const SF_CASE_INSTRUCTIONS_MAXLENGTH = 225;
